import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Route guard that only allows role="admin" to enter.
 * Non-admins get bounced to the module chooser.
 */
export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) return null;
  if (!user) {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
